export const getApi = () => {
	if(window.location.href.includes('localhost')){
		return 'http://translationtool.ddev.site/api/'
	}
	return '/api/';
};

export const getGraphql = () => {
	if(window.location.href.includes('localhost')){
		return 'http://translationtool.ddev.site/graphql/';
	}

	return window.location.protocol + '//' + window.location.host + '/graphql/';
};

export const showAdminFunctions = () => {
	return window.admin;
};

export const getCsrfToken = () => {
	return window.csrf;
};



// WEBPACK FOOTER //
// ./React/src/services/settings.js